<section class="ticker-section" *ngIf="!loading && cards.length">
  <div class="ticker-track">
    <!-- Triple the cards for seamless infinite scroll -->
    <ng-container *ngFor="let repeat of [0, 1, 2]">
      <a *ngFor="let card of cards; let i = index"
         class="ticker-card glass-panel"
         [routerLink]="['/prices', card.code + '-' + card.baseCurrency]"
         [attr.aria-hidden]="repeat > 0 ? true : null">

        <div class="ticker-header">
          <span class="ticker-pair">{{card.pair}}</span>
          <span class="ticker-change" [class.change-up]="card.isUp" [class.change-down]="!card.isUp">
            {{card.isUp ? '+' : ''}}{{card.changePercent | number:'1.2-2'}}%
          </span>
        </div>

        <div class="ticker-price">{{card.price | roundNumberPrice}}</div>

        <svg class="mini-chart" viewBox="0 0 100 30" preserveAspectRatio="none">
          <defs>
            <linearGradient [attr.id]="card.gradientId + '-' + repeat" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" [attr.stop-color]="card.isUp ? colorUp : colorDown"/>
              <stop offset="100%" stop-color="transparent"/>
            </linearGradient>
          </defs>
          <ng-container *ngIf="card.sparklinePath; else fallbackChart">
            <path [attr.d]="card.sparklinePath" fill="none" [attr.stroke]="card.isUp ? colorUp : colorDown" stroke-width="2"/>
            <path [attr.d]="card.sparklineFill" [attr.fill]="'url(#' + card.gradientId + '-' + repeat + ')'" opacity="0.2"/>
          </ng-container>
          <ng-template #fallbackChart>
            <path [attr.d]="card.isUp ? 'M0,25 C20,20 40,25 60,10 C80,-5 100,10 100,10' : 'M0,10 C20,15 40,5 60,20 C80,35 100,25 100,25'"
                  fill="none" [attr.stroke]="card.isUp ? colorUp : colorDown" stroke-width="2"/>
            <path [attr.d]="card.isUp ? 'M0,25 C20,20 40,25 60,10 C80,-5 100,10 100,10 L100,30 L0,30 Z' : 'M0,10 C20,15 40,5 60,20 C80,35 100,25 100,25 L100,30 L0,30 Z'"
                  [attr.fill]="'url(#' + card.gradientId + '-' + repeat + ')'" opacity="0.2"/>
          </ng-template>
        </svg>
      </a>
    </ng-container>
  </div>
</section>
